import { z } from 'zod/v4-mini';

export const messageDataSchema = z
  .object({
    visibility: z.literal(['practitioners', 'all'], {
      error: 'form.required',
    }),
    contentText: z.string(),
    contentAttachment: z.array(z.file()),
  })
  .check(
    z.refine(data => data.contentText || data.contentAttachment.length > 0, {
      // Error has to be attributed to a field
      path: ['contentText'],
    }),
  );

export type MessageData = z.infer<typeof messageDataSchema>;
